import { createSelector } from '@ngrx/store';
import * as fromRoot from '@core/reducers/root.reducer';

export const getCommentsPopulated = createSelector(
  fromRoot.getCommentsPopulated,
  fromRoot.getFollowsPopulated,
  (comments: any[], follows: any[]) =>
    comments.map(comment => {
      let follow = follows.find(f => f.id === comment.followId);
      if (follow) {
        follow = {
          ...follow,
          name: `${follow.department &&
            follow.department.name}-${follow.season && follow.season.name}-${
            follow.year
          }`
        };
      }
      return { ...comment, follow };
    })
);
